// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"Filtro.styles_dataTableFormat__3WDh5","formSpace":"Filtro.styles_formSpace__d4UZz"};